import React, { useEffect, useRef, useState } from 'react';
import axios from '../config';
import dayjs from "dayjs";
import Cookies from 'js-cookie';

import { Bar, Line } from "react-chartjs-2";
import Chart from 'chart.js/auto';

import cl from '../static/style.module.css'

import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';

//


const Dashboard = () => {


    const [todayQty, setTodayQty] = useState({})
    const [lastdays, setLastDays] = useState(0)
    const [lineData, setLineData] = useState({})
    const daysRef = useRef(0)

    const [data, setData] = useState({})


    const setUpdateLastDays = (e) => {
        const next = e < 0 || Number.isNaN(e) ? 0 : e
        daysRef.current = next
        setLastDays(next)
    }

    Chart.defaults.font.size = 11;


    const getStats = async () => {
        const requested = daysRef.current
        const rs = await axios.post('ustats', { 'days': requested }, {headers:{'token': Cookies.get('token')}})
        if (requested !== daysRef.current) {
            return
        }
        if (rs.status === 200) {
            const data = rs.data
            setData(data)
            console.log(data)
            setTodayQty({
                labels: data.source,
                datasets: [{
                    label: `Кол-во (${data.sum_total_qte} шт.)`,
                    data: data.totalQuantity,
                    backgroundColor: ['rgba(255, 99, 132, 0.3)', 'rgba(255, 159, 64, 0.3)', 'rgba(255, 205, 86, 0.3)', 'rgba(75, 192, 192, 0.3)', 'rgba(54, 162, 235, 0.3)', 'rgba(153, 102, 255, 0.3)', 'rgba(201, 203, 207, 0.3)', 'rgba(221, 203, 207, 0.3)'],
                    borderColor: ['rgb(255, 99, 132)', 'rgb(255, 159, 64)', 'rgb(255, 205, 86)', 'rgb(75, 192, 192)', 'rgb(54, 162, 235)', 'rgb(153, 102, 255)', 'rgb(221, 203, 207)'],
                    borderWidth: 1
                }]
            })

            setLineData({
                labels: data.seven_days.days.map(d => dayjs(d).format('DD/MM/YYYY')),
                datasets: Object.entries(data.seven_days.source).map(([k, v]) => ({ 
                        label: k, 
                        data: v, 
                        tension: 0.3, 
                        borderWidth: 1,
                        pointRadius: 2 })),
            })

        }
    }

    const chartOptions = {
        scales: {
            x: {},
            y: {
                min: 0,
                ticks: {
                    precision: 0,
                }
            }
        }
    }


    const updateLastDays = (days, fix) => {

        if (fix === 'early_menth') {

            let now = dayjs()
            let debut = dayjs().set('date', 0)
            daysRef.current = now.diff(debut, 'days')
            setLastDays(daysRef.current)

        } else if (fix === 'early_year') {

            let now = dayjs()
            let debut = dayjs().set('month', 0).set('date', 0)
            daysRef.current = now.diff(debut, 'days')
            setLastDays(daysRef.current)

        } else {
            daysRef.current = days
            setLastDays(days)
        }
    }


    const totalArrey = (arr) => {
        let sm = 0
        arr.map(i => sm = sm + i)
        return sm
    }


    const wigthTableCountry = (data, v) => {
        let d = Object.keys(data).length * v + 50
        return d
    }



    const configLine = {
        type: 'line',
        data: lineData,
        
    };



    useEffect(() => {
        const interval = setInterval(() => {
            getStats()
        }, 1000 * 60);
        return () => clearInterval(interval);

        // getStats()
    }, [lastdays])


    useEffect(() => {
        getStats()
    }, [lastdays])

    return (
        <div>
            <Box
                component="form"
                sx={{ '& > :not(style)': {}, }}
                noValidate
                autoComplete="off"
            >

                {/* {Title()} */}
                <TextField
                    id={cl.text_area_box}
                    label="кол-во дней"
                    variant="outlined"
                    value={lastdays}
                    onChange={(e) => setUpdateLastDays(+e.target.value)}
                    size="small"
                    type='number'
                    min='0'
                    autoComplete="off"
                    sx={{ mr: 1, width:'100px' }}
                />

                <Button
                    variant="outlined"
                    // size="small"
                    onClick={() => updateLastDays(0, 'early_year')}
                    sx={{ mx: 1, fontSize: 10, mt: 1 }}
                >С начала года</Button>

                <Button
                    variant="outlined"
                    // size="small"
                    onClick={() => updateLastDays(0, 'early_menth')}
                    sx={{ mx: 1, fontSize: 10, mt: 1 }}
                >С начала месяца</Button>

                <Button
                    variant="outlined"
                    // size="small"
                    onClick={() => updateLastDays(30, 'fix')}
                    sx={{ mx: 1, fontSize: 10, mt: 1 }}
                >За последние 30 дней</Button>

                <Button
                    variant="outlined"
                    // size="small"
                    onClick={() => updateLastDays(7, 'fix')}
                    sx={{ mx: 1, fontSize: 10, mt: 1 }}
                >За последние 7 дней</Button>

                <Button
                    variant="outlined"
                    // size="small"
                    onClick={() => updateLastDays(0, 'fix')}
                    sx={{ mx: 1, fontSize: 10, mt: 1 }}
                >Сегодня</Button>
            </Box>



            {/* CHART */}
            <div style={{ maxWidth: 700, marginTop: '30px' }} >
                {data?.totalQuantity ? <Bar data={todayQty} options={chartOptions} sx={{ position: 'relative', hight: 300 }} /> : ''}
            </div>



            {/* BY SOURCE */}
            {data.source ?
                <TableContainer component={Paper} sx={{ mt: '30px', width: 800 }}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow sx={{ whiteSpace: 'nowrap' }} >
                                {data.source.map((i, index) => <TableCell key={index}>
                                    <Typography variant='caption' color="initial">
                                        {i}
                                    </Typography>
                                </TableCell>)}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                {data.totalQuantity.map((i, index) =>
                                    <TableCell key={index} component="th" scope="row">
                                        {i ? <Typography variant='caption' color="initial">
                                            {i}
                                        </Typography> : ''}
                                    </TableCell>
                                )}
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                : ''}



            {/* BY DIVISION */}
            {data.divisions ?
                <TableContainer sx={{ mt: '30px', width: 200 }} component={Paper}>
                    <Table size="small" >
                        <TableHead>
                            <TableRow>
                                {data.divisions.map((i, index) => <TableCell key={index}>
                                    <Typography variant='caption' color="initial">
                                        {i}
                                    </Typography>
                                </TableCell>)}
                                <TableCell><Typography variant='caption' color="initial">
                                    Total
                                </Typography></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                {data.divisions_counts.map((i, index) =>
                                    <TableCell key={index} component="th" scope="row">
                                        <Typography variant='caption' color="initial">
                                            {i}
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell>
                                    <Typography variant='caption' color="initial">
                                        {totalArrey(data.divisions_counts)}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                : ''}



            {/* BY COUNTRY */}
            {data.countries ?
                <TableContainer component={Paper} sx={{ mt: '30px', width: wigthTableCountry(data.countries, 85) }}>
                    <Table size="small"  >
                        <TableHead>
                            <TableRow>
                                {Object.keys(data.countries).map(key =>
                                    <TableCell sx={{ whiteSpace: 'nowrap', width: 50 }} key={key}>
                                        <Typography variant='caption' color="initial">
                                            {key}
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell>
                                    <Typography variant='caption' color="initial">
                                        Total
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                {Object.values(data.countries).map((value, index) =>
                                    <TableCell key={index} component="th" scope="row">
                                        <Typography variant='caption' color="initial">
                                            {value}
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell>
                                    <Typography variant='caption' color="initial">
                                        {totalArrey(data.divisions_counts)}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                : ''}
            
            
            {lineData.labels ? 
            <div style={{ maxWidth: 700, marginTop: '30px' }} >
                <Line data={lineData} onDoubleClick={() => console.log(lineData)} config={configLine} options={chartOptions}  sx={{ position: 'relative', hight: 300 }} /> 
            </div>: ''}


            {/* BY DAY */}
            {data.per_days && Object.keys(data.per_days).length > 1 ?
                <TableContainer component={Paper} sx={{ mt: '30px', width: wigthTableCountry(data.per_days, 105) }}>
                    <Table size="small"  >
                        <TableHead>
                            <TableRow>
                                {Object.keys(data.per_days).map(key =>
                                    <TableCell sx={{ whiteSpace: 'nowrap', width: 50 }} key={key}>
                                        <Typography variant='caption' color="initial">
                                            {dayjs(key).format('DD/MM/YYYY')}
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell>
                                    <Typography variant='caption' color="initial">
                                        Total
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                {Object.values(data.per_days).map((value, index) =>
                                    <TableCell key={index} component="th" scope="row">
                                        <Typography variant='caption' color="initial">
                                            {value}
                                        </Typography>
                                    </TableCell>
                                )}
                                <TableCell>
                                    <Typography variant='caption' color="initial">
                                        {totalArrey(data.divisions_counts)}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                : ''}

        </div>
    );
}

export default Dashboard;
